/* Mobile UI-Korrekturen fuer den LPD Designer. Laeuft additiv nach dem
   Haupt-Asset, damit Bestand, Preis- und Warenkorblogik unberuehrt bleiben. */
(function () {
  'use strict'
  var root = document.querySelector('[data-lpd-designer]')
  var cfgEl = document.querySelector('[data-lpd-config]')
  if (!root || !cfgEl) return
  var boot = JSON.parse(cfgEl.textContent)
  var compactEmptyState = !!boot.compactEmptyState
  var stage = root.querySelector('[data-stage]')
  var area = root.querySelector('[data-area]')
  var empty = root.querySelector('.lpd-dsg__empty')
  var drop = root.querySelector('.lpd-dsg__drop')
  var mbarSub = root.querySelector('[data-mbar-sub]')
  var qtyVal = root.querySelector('[data-qty-val]')
  var tabs = root.querySelector('.lpd-dsg__tabs')
  if (!stage || !area || !empty || !drop) return

  var dropTitle = drop.querySelector('b')
  var dropSub = drop.querySelector('span')
  var fullLabel = dropTitle ? dropTitle.textContent : ''
  // Das optionale Section-Setting setzt diese beiden Werte inline. Beim
  // Zurücksetzen dürfen sie nicht verloren gehen, sonst springt Desktop wieder
  // in die Mitte und nur der mobile Area-Fallback bleibt sichtbar.
  var configuredPaddingTop = empty.style.paddingTop
  var configuredPlaceItems = empty.style.placeItems

  function resetEmpty() {
    empty.classList.remove('is-area-bound', 'is-tiny', 'is-micro')
    empty.style.left = ''; empty.style.top = ''; empty.style.width = ''; empty.style.height = ''
    empty.style.paddingTop = configuredPaddingTop; empty.style.placeItems = configuredPlaceItems
    if (dropTitle) dropTitle.textContent = fullLabel
    if (dropSub) dropSub.hidden = false
  }

  function layoutEmpty() {
    resetEmpty()
    if (window.innerWidth >= 960) return
    if (!compactEmptyState) return
    var ar = area.getBoundingClientRect(), sr = stage.getBoundingClientRect()
    if (!ar.width || !ar.height) return
    var dr = drop.getBoundingClientRect()
    var alreadyInside = dr.left >= ar.left - .6 && dr.top >= ar.top - .6
      && dr.right <= ar.right + .6 && dr.bottom <= ar.bottom + .6
    // Nur bei echtem Ueberlauf oder falscher Lage eingreifen. AS-Colour-Flaechen,
    // deren bisheriger Hinweis bereits im Rahmen liegt, bleiben pixelgenau gleich.
    if (alreadyInside && ar.width >= drop.scrollWidth + 8 && ar.height >= drop.scrollHeight + 8) return
    empty.classList.add('is-area-bound')
    var tiny = ar.width < 132 || ar.height < 72
    var micro = ar.width < 72 || ar.height < 42
    empty.classList.toggle('is-tiny', tiny)
    empty.classList.toggle('is-micro', micro)
    // Exakt dieselben CSS-Koordinaten wie der Rahmen verwenden. Aus
    // getBoundingClientRect zurueckgerechnete Werte hatten an der 1px-Stagekante
    // je nach Zoom einen Rundungsfehler.
    empty.style.left = area.style.left; empty.style.top = area.style.top
    empty.style.width = area.style.width; empty.style.height = area.style.height
    // Der Hinweis sitzt im oberen Drittel des kalibrierten Rahmens.
    empty.style.paddingTop = (micro ? 1 : Math.max(5, Math.min(16, ar.height * .16))) + 'px'
    if (tiny) {
      if (dropTitle) dropTitle.textContent = micro ? '+' : '+ Motiv'
      if (dropSub) dropSub.hidden = true
    }
  }

  function updateStickyLabel() {
    if (!mbarSub || !boot.stickyBlankAsFrom) return
    var qtySelected = qtyVal && !/^Noch nichts gewählt/.test(qtyVal.textContent.trim())
    if (qtySelected) return // Haupt-Asset zeigt Menge und Stueckpreis bereits korrekt.
    var hasPrint = tabs && tabs.querySelector('button.has')
    var text = hasPrint ? 'pro Stück · Druck inkl.' : 'ab · zzgl. Druck'
    if (mbarSub.textContent !== text) mbarSub.textContent = text
  }

  function moveChatAboveSticky() {
    if (window.innerWidth >= 960) return
    var chat = document.querySelector('shopify-chat')
    if (chat) chat.style.setProperty('--shopify-chat-activator-offset', 'calc(87px + env(safe-area-inset-bottom))', 'important')
  }

  function refresh() {
    window.requestAnimationFrame(function () { layoutEmpty(); updateStickyLabel(); moveChatAboveSticky() })
  }
  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-side],.lpd-dsg__sw,.lpd-dsg__thumb,[data-remove]')) refresh()
  })
  if (window.ResizeObserver) new ResizeObserver(refresh).observe(stage)
  else window.addEventListener('resize', refresh)
  new MutationObserver(updateStickyLabel).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] })
  if (!document.querySelector('shopify-chat')) {
    var chatObserver = new MutationObserver(function () {
      if (document.querySelector('shopify-chat')) { moveChatAboveSticky(); chatObserver.disconnect() }
    })
    chatObserver.observe(document.body, { childList: true, subtree: true })
  }
  refresh()
})()
